import styled from "styled-components";

export const HomeContainer = styled.div`
	@media screen and (min-width: 0px) {
		section#wellcome {
			background-color: var(--grey-color);

			.button-group {
				.text-separator {
					&::before,
					&::after {
						background-color: var(--grey-dark-color);
					}
				}

				.btn-primary {
					padding: 0.7em 1em;

					&:hover {
						background-color: transparent;
					}
				}

				.btn-secundary {
					padding: 0.7em 1em;
					background-color: transparent;

					&:hover {
						background-color: var(--primary-color);
					}
				}
			}
		}

		section.container-scroll {
			display: flex;
			flex-direction: column;

			width: 100%;
			max-width: 100%;
			background-color: var(--secundary-color);
			padding: 2em 1em;

			.title {
				color: var(--grey-dark-color);
				font-size: 2em;
				margin-top: 0;
				margin-bottom: 0;

				span {
					color: var(--grey-dark-color);
					font-size: 1em;
				}
			}

			.block-list {
				display: flex;
				flex-wrap: nowrap;
				max-width: 100%;
				overflow-x: auto;
				padding: 1.5rem 0;
				margin-bottom: 1em;

				.block {
					display: block;
					min-width: 310px;
					max-width: 310px;
					border: 1px dashed var(--white);
					border-radius: 5px;
					padding: 1em;
					flex: 1 1 100%;

					& + .block {
						margin-left: 1em;
					}

					&__title {
						font-family: "PFSquareSansProBold", sans-serif;
						text-transform: uppercase;
						font-size: 1.125em;
						color: var(--white);
						margin-top: 0;
					}

					&__content {
						font-family: "PFSquareSansProMedium", sans-serif;
						color: var(--grey-dark-color);
					}
				}
			}

			.link {
				text-decoration: underline;
				color: var(--grey-dark-color);
				font-family: "PFSquareSansProBold", sans-serif;
				font-size: 1.125em;
			}
		}

		.container-form {
			background-color: var(--grey-color);
		}

		section#operation, section#register, section#stores-participants {
			scroll-margin-top: 60px;
		}

		section#stores-participants {
			margin-top: 1.2em;
			margin-bottom: 3em;

			.title {
				margin-bottom: 2em;
			}

			.btns-group {
				width: 100%;
				display: flex;

				.btn-stores {
					flex: 1 1 auto;
					border: 1px solid #ccc;
					padding: 10px 30px;
					font-size: 1.2em;
					font-weight: 600;
					background-color: var(--white);
					color: var(--dark);
					transition: all 0.3s ease;
					outline: none;

					& + .btn-stores {
						margin-left: 2em;
					}

					&:hover,
					&:focus,
					&:active,
					&:visited,
					&.active {
						background-color: var(--secundary-color);
						color: var(--white);
						border-color: transparent;
						outline: none;
					}
				}
			}

			.text-content {
				font-size: 1.125em;
				font-weight: 500;
				margin-top: 3em;
				margin-bottom: 1.4em;
			}

			.search-zip {
				width: 100%;
				display: flex;
				align-items: center;

				label {
					position: relative;
					flex: 1 1 auto;
					max-width: 245px;
					outline: none;

					input {
						width: 100%;
						border: 1px solid #b2b2b2;
						padding-left: 10px;
						height: 45px;
						line-height: 45px;
						outline: none;

						&::placeholder {
							color: #c8c8c8;
						}
					}

					span {
						position: absolute;
						right: 15px;
						top: 50%;
						transform: translateY(-50%);

						svg path {
							stroke: #222;
						}
					}
				}

				a {
					margin-left: 2em;
				}
			}

			.search-result {
				font-family: "PFSquareSansProBold", sans-serif;
				font-size: 1em;
				color: var(--primary-color);
				margin: 2em 0;
			}

			.stores {
				.store {
					position: relative;
					display: flex;
					margin-bottom: 3em;

					&__image {
						width: 80px;
						height: 80px;
						border: 1px solid #ccc;
						padding: 8px;
					}

					.store-content {
						flex: 1 1 auto;
						display: flex;
						flex-direction: column;
						justify-content: space-between;
						margin-left: 1em;

						&__title {
							font-size: 1.2em;
							font-weight: bold;
							color: var(--auxiliary-color);
							margin: 0;
						}

						&__link {
							text-decoration: none;
							font-weight: 300;
							color: var(--white);
							text-transform: uppercase;
							background-color: var(--primary-color);
							padding: 10px 30px;
							width: 135px;
							width: max-content;
						}
					}

					&::before {
						position: absolute;
						left: 15px;
						right: 15px;
						bottom: -1.5em;
						display: inline-block;
						content: "";
						width: 90%;
						max-width: 100%;
						height: 1px;
						background-color: #ccc;
					}
				}
			}
		}

		section.about {
			width: 100%;
			min-height: 192px;
			background-image: url(${require("@/assets/img/gato.png").default});
			background-size: cover;

			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;

			.content {
				display: flex;
				flex-direction: column;
				align-items: center;

				h2 {
					font-family: "PFSquareSansProBold", sans-serif;
					margin-top: 0;
					font-size: 2.625em;
					font-weight: 900;
					color: var(--white);
					margin-bottom: 1.5rem;
				}

				a {
					display: block;
					max-width: 153px;
					color: var(--white);
					text-decoration: none;
					border: 1px solid var(--white);
					padding: 0.75em 2em;
					transition: all 0.3s;

					&:hover {
						background-color: var(--white);
						color: var(--primary-color);
					}
				}
			}
		}
	}

	@media screen and (min-width: 992px) {
		.header {
			display: flex;
			flex-direction: column;

			h1 {
				font-size: 1.5em;
				text-align: left;
				span {
					color: var(--auxiliary-color);
				}
			}

			h2 {
				margin-top: 0;
				font-size: 2.938em;
				text-align: left;
				/* max-width: 35vw; */
			}

			div.button-group {
				margin: initial;
				order: 1;
			}
		}

		.dekstop-spotlight {
			font-family: "PFSquareSansProMedium", sans-serif;
			font-size: 36px;
			line-height: 1.2;
			text-align: center;
		}

		section.container-scroll {
			align-items: center;

			.title {
				text-align: center;
			}

			.link {
				display: block;
				text-align: center;
			}

			.block-list {
				.block {
					&__content {
						font-size: 1.125em;
					}
				}
			}
		}

		.container-form {
			header.header-group {
				h2 {
					font-size: 2.25em;
					margin-bottom: 0;
					text-align: center;
				}

				h3 {
					margin-top: 0.7em;
					text-align: center;
					font-size: 1.313em;
					font-weight: 600;
				}
			}
		}

		section.stores {
			h2 {
				text-align: center;
			}
		}

		section.about {
			min-height: 300px;
			background-image: url(${require("@/assets/img/gato@3x.png")
		.default});

			.content {
				align-items: flex-start;
				margin-left: 15vw;

				h2 {
					font-size: 3.75em;
					margin-bottom: 1.5rem;
				}
			}
		}
	}
`;
